

import React from 'react';
import { Container, Card, CardBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSchool, faExternalLinkAlt, faBook, faFlask, faDesktop, faGamepad, faHome } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
import img from './../../assets/Asthal.jpg';

const Asthal = () => {
    const facilities = [
        { name: 'Spacious Classrooms', icon: faHome },
        { name: 'Well-equipped Laboratories', icon: faFlask },
        { name: 'Computer Science Lab', icon: faDesktop },
        { name: 'School Library', icon: faBook },
        { name: 'Indoor & Outdoor Games', icon: faGamepad }
    ];

    return (
        <>
            <div style={{
                backgroundImage: `url(${footerBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '30px 0',
                color: 'white',
                margin: '2%',
                borderRadius: '10px'
            }}>
                <Container>
                    <h3 className="fw-bold mb-0 text-center">
                        <FontAwesomeIcon icon={faSchool} className="me-2" />
                        Shri Baba Mastnath Senior Secondary (Res) Public School Asthal Bohar, (Rohtak)
                    </h3>
                </Container>
            </div>

            <Container className="py-5">
                <div className="mb-4">
                    <img 
                        src={img} 
                        alt="Shri Baba Mastnath School" 
                        style={{
                            width: '100%',
                            height: '370px',
                            objectFit: 'cover',
                            borderRadius: '20px',
                            boxShadow: '0 12px 40px rgba(30,60,114,0.15)'
                        }}
                    />
                </div>

                <Card className="border-0 mb-4" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                        padding: '25px',
                        color: 'white'
                    }}>
                        <h4 className="fw-bold mb-0">
                            <FontAwesomeIcon icon={faSchool} className="me-2" />
                            About the School
                        </h4>
                    </div>
                    <CardBody className="p-4">
                        <div className="mb-4">
                            <h6 style={{ color: '#1e3c72', fontWeight: '600' }}>(Affiliated to C.B.S.E – Affiliated Code-530116)</h6>
                        </div>
                        
                        <div className="mb-4">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                The School is situated along Delhi-Rohtak Road (N.H-09) at a distance of 5 KM. from Rohtak. Asthal Bohar Math is holy seat of Nath Sect ( नाथ सम्प्रदाय ). People from far flung areas come here to pay their obeisance and seek blessings from Baba Mastnath. A big fair is held for three days (7-8-9) during second fortnight of 'Phalgun' ( फाल्गुन मास शुक्ल पक्ष ).
                            </p>
                        </div>
                        
                        <div className="mb-4">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                This School was established by His Holiness Mahent Chand NathYogi ji during the year 1989 with the sole intention of imparting quality education to Children from adjoining areas.
                            </p>
                        </div>
                        
                        <div className="mb-4">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                The School is an English Medium, Co-Educational and up to Senior Secondary level. Currently we have two streams at +2 level; Science Stream (Medical and Non- Medical) and Commerce Stream.
                            </p>
                        </div>
                        
                        <div className="mb-4">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                After sad and untimely demise of Mahent Chand Nath Yogi ji, his disciple Mahent Balak Nath ji Yogi has succeeded as Mahent Asthal Bohar Math. Rev, Balak Nath ji Yogi is a great Visionary and has big plans for this School. Academic Excellence along with excellence in games and sports associated with inculcation of social &cultural values on the sidelines of Gurukul system of Education ( संस्कार युक्तशिक्षा ) are in the pipe line. Baba Mast Nath University is being run by Asthal Bohar Math. Rev. Balak Nath ji Yogi is the Current Chancellor of Shri Baba Mast Nath University which provides Best Educational Facilities in the field of Humanities, Science, Law, Ayurveda, M.B.A, B. Pharma, Teaching Training et al.
                            </p>
                        </div>
                    </CardBody>
                </Card>

                <Card className="border-0 mb-4" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                        padding: '25px',
                        color: 'white'
                    }}>
                        <h4 className="fw-bold mb-0">
                            <FontAwesomeIcon icon={faHome} className="me-2" />
                            School Facilities
                        </h4>
                    </div>
                    <CardBody className="p-4">
                        <div className="mb-4">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                Our School has spacious Class rooms, well equipped laboratories in Physics, Chemistry, Biology and Computer Science, A wide range of Books are available in the School Library and also equipment for various Indoor and outdoor Games. A serene environment awaits your visit.
                            </p>
                        </div>
                        
                        <div className="row justify-content-center">
                            {facilities.map((facility, index) => (
                                <div key={index} className="col-md-6 col-lg-4 mb-3">
                                    <div 
                                        className="p-3 text-center rounded"
                                        style={{
                                            background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                                            color: 'white',
                                            minHeight: '80px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            boxShadow: '0 4px 15px rgba(22,160,133,0.2)',
                                            transition: 'all 0.3s'
                                        }}
                                        onMouseOver={(e) => {
                                            e.currentTarget.style.transform = 'scale(1.05)';
                                            e.currentTarget.style.boxShadow = '0 8px 25px rgba(22,160,133,0.3)';
                                        }}
                                        onMouseOut={(e) => {
                                            e.currentTarget.style.transform = 'scale(1)';
                                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(22,160,133,0.2)';
                                        }}
                                    >
                                        <FontAwesomeIcon 
                                            icon={facility.icon} 
                                            style={{ fontSize: '2rem', marginBottom: '10px' }}
                                        />
                                        <h6 className="mb-0 fw-bold">{facility.name}</h6>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </CardBody>
                </Card>

                <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
                        padding: '25px',
                        color: 'white'
                    }}>
                        <h4 className="fw-bold mb-0">
                            <FontAwesomeIcon icon={faExternalLinkAlt} className="me-2" />
                            View More Details
                        </h4>
                    </div>
                    <CardBody className="p-4">
                        <div className="text-center">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem', marginBottom: '20px' }}>
                                For more information about our school, programs, and admission details, please visit our official website.
                            </p>
                            <a
                                href='https://www.sbmnssrps.com/contact.php'
                                target='_blank'
                                rel='noopener noreferrer'
                                style={{
                                    color: '#8e44ad',
                                    textDecoration: 'none',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    padding: '12px 24px',
                                    borderRadius: '25px',
                                    border: '2px solid #8e44ad',
                                    transition: 'all 0.3s'
                                }}
                                onMouseOver={(e) => {
                                    e.currentTarget.style.background = '#8e44ad';
                                    e.currentTarget.style.color = 'white';
                                    e.currentTarget.style.transform = 'scale(1.05)';
                                }}
                                onMouseOut={(e) => {
                                    e.currentTarget.style.background = 'transparent';
                                    e.currentTarget.style.color = '#8e44ad';
                                    e.currentTarget.style.transform = 'scale(1)';
                                }}
                            >
                                <FontAwesomeIcon icon={faExternalLinkAlt} />
                                Visit Official Website
                            </a>
                        </div>
                    </CardBody>
                </Card>
            </Container>
        </>
    );
};

export default Asthal;
